import {
    addPendingAnimation,
    onAnimationCompletedMutator,
    removeActiveAnimationMutator,
    type MailListItemAnimation,
} from 'owa-mail-list-item-animation-store';
import { invokeAnimationCallback } from './invokeAnimationCallback';
import { getNextActionId } from './getNextActionId';
import { resetFocus } from 'owa-mail-focus-manager';
import { isFeatureEnabled } from 'owa-feature-flags';

export function handleAnimationComplete(animation: MailListItemAnimation, rows: Element[]): void {
    const { animationAction, animationRowIds, animationCallback } = animation;
    if (animationAction == 'PinInitial' || animationAction == 'UnpinInitial') {
        rows.forEach(row => {
            if (animationRowIds?.has(row.id)) {
                (row as HTMLDivElement).style.background = '';
            }
        });
        addPendingAnimation(
            /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion  -- (https://aka.ms/OWALintWiki)
             * Non-null assertions are dangerous, as they can hide bugs from strictness checks. Please remove this usage or replace this line with a justification.
             *	> Forbidden non-null assertion. */
            Array.from(animationRowIds!),
            getNextActionId(animationAction),
            animationCallback
        );
        removeActiveAnimationMutator(animation);
    } else if (animationAction == 'PinMiddle' || animationAction == 'UnpinMiddle') {
        /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion  -- (https://aka.ms/OWALintWiki)
         * Non-null assertions are dangerous, as they can hide bugs from strictness checks. Please remove this usage or replace this line with a justification.
         *	> Forbidden non-null assertion. */
        addPendingAnimation(Array.from(animationRowIds!), getNextActionId(animationAction));
        removeActiveAnimationMutator(animation);
    } else if (
        animationAction == 'PinFinal' ||
        animationAction == 'UnpinFinal' ||
        animationAction == 'AddRowFinal'
    ) {
        rows.forEach(row => {
            if (animationRowIds?.has(row.id)) {
                (row as HTMLDivElement).style.background = '';
                (row as HTMLDivElement).style.visibility = '';
                (row as HTMLDivElement).style.height = '';
            }
        });
        removeActiveAnimationMutator(animation);
    } else if (animationAction == 'AddRowInitial') {
        rows.forEach(row => {
            if (animationRowIds?.has(row.id)) {
                (row as HTMLDivElement).style.visibility = 'hidden';
                (row as HTMLDivElement).style.height = '0';
            }
        });
        /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion  -- (https://aka.ms/OWALintWiki)
         * Non-null assertions are dangerous, as they can hide bugs from strictness checks. Please remove this usage or replace this line with a justification.
         *	> Forbidden non-null assertion. */
        addPendingAnimation(Array.from(animationRowIds!), getNextActionId(animationAction));
        removeActiveAnimationMutator(animation);
    } else {
        rows.forEach(row => {
            if (animationRowIds?.has(row.id)) {
                (row as HTMLDivElement).style.opacity = '0';
            }
        });
        invokeAnimationCallback(animation);
        onAnimationCompletedMutator(animation);
        // After row is removed (and animated away), we'll call resetFocus to re-focus
        // the ML as the previously focused row is no longer in the DOM.
        if (!isFeatureEnabled('tri-virtuoso')) {
            resetFocus('handleAnimationComplete');
        }
    }
}
